<template><!-- MULTIPLE COLUMNS-->
    <div class="vx-col w-full">
      <vx-card>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm">Select Partner*</label>
              <v-select
                :options="partners"
                :reduce="item => item.value" label="label"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-validate="'required'"
                class="w-full"
                name="Partner"
                :value="Payment.Partner"
                v-model="Payment.Partner"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Partner') && isSaveForm"
              >{{ errors.first('Partner') }}.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
           <flat-pickr :config="configFromdateTimePicker"  v-validate="'required'" name="PaidDate" class="w-full" :value="Payment.PaidDate" v-model="Payment.PaidDate" placeholder="Paid Date"  @on-change="changeConfig()"/>
            <span
              class="text-danger text-sm"
              v-show="errors.has('PaidDate') && isSaveForm"
            >The Paid Date field is required.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input type="number" class="w-full" v-validate="'required'" name="Amount" :value="Payment.Amount" label-placeholder="Amount*" v-model="Payment.Amount" />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Amount') && isSaveForm"
            >{{ errors.first('Amount') }}.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input type="text" class="w-full" v-validate="'required'" name="Subject" :value="Payment.Subject" label-placeholder="Subject*" v-model="Payment.Subject" />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Subject') && isSaveForm"
            >{{ errors.first('Subject') }}.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-textarea class="mb-2 mt-5" type="text" placeholder="Description" :value="Payment.Description" v-model="Payment.Description" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-checkbox v-model="Payment.IsHidden">Is Hidden</vs-checkbox>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click.prevent="savePayment">Save</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click.native="$router.push('/apps/payments/payment-list')">Cancel</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
</template>

<script>
import "@/assets/css/main.css";
import PartnerService from "@/services/PartnerService";
import PaymentService from "@/services/PaymentService";
import UtilService from "@/services/UtilService";
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default{
  data () {
    return {
      configFromdateTimePicker: {
        dateFormat: "Y-m-d h:i K",
      },
      userInfo : {},
      userZone : "",
      oldPartnerValue: "",
      Payment:{
        Partner: '',
        Amount: '',
        Subject: '',
        PaidDate: '',
        Description: '',
        IsHidden: 1,
        IsDeleted: 0,
        CreatedBy: "",
        ModifiedBy: ""
      },
      partners: [],
      isSaveForm: false
    }
  },
  components: {
    "v-select": vSelect,
    flatPickr
  },
  watch: {
    '$route' (to, from) {
      // Reset form here
        this.Payment = {
        Partner: '',
        Amount: '',
        Subject: '',
        PaidDate: '',
        Description: '',
        IsHidden: 1,
        IsDeleted: 0,
        CreatedBy: "",
        ModifiedBy: ""
      }
    },
  },
  methods: {
    changeConfig(){
      this.configFromdateTimePicker = {
        dateFormat: "Y-m-d "+(new Date().getHours()>12 ? ('0'+new Date().getHours()%12).slice(-2) : ('0'+new Date().getHours()).slice(-2)) + ":" + ('0'+new Date().getMinutes()).slice(-2)+(new Date().getHours()>=12 ? " P\\M" : " A\\M")
      }
    },
    fetchPaymentData(paymentId) {
      PaymentService.getById(paymentId).once("value", item => {
        if (item && item.val()) {
          this.Payment = item.val();
          this.Payment['PaidDate'] = this.Payment['PaidDate'] ? UtilService.convertUTCToCurrentZone(this.Payment['PaidDate'],this.userZone) : "";
          this.oldPartnerValue = (this.Payment)? this.Payment.Partner : '';
        }
      });
    },
    savePayment() {
      this.isSaveForm = true
      this.$validator.validateAll().then(result => {
        if (result) {
          this.Payment['PaidDate'] = this.Payment['PaidDate'] ? UtilService.convertUserTimeZoneToUTC(this.Payment['PaidDate'],this.userZone) : "";
          if (this.$route.params.paymentId) {
            this.Payment["ModifiedBy"] = this.userInfo['Id'];
            PaymentService.update(this.$route.params.paymentId, this.Payment)
              .then(() => {
                this.$router.push("/apps/payments/payment-list");
                UtilService.notifySuccessAlert(
                  this.$vs,
                  "Payment updated successfully."
                );
              })
              .catch(e => {
                console.log(e);
              });
          } else {
            this.Payment["CreatedBy"] = this.userInfo['Id'];
            this.Payment['Number'] =  Math.floor(100000 + Math. random() * 900000) 

            PaymentService.create(this.Payment)
              .then(obj => {
                if (!obj.val()) {
                  this.$router.push("/apps/payments/payment-list");
                  UtilService.notifySuccessAlert(
                    this.$vs,
                    "Payment created successfully."
                  );
                } else {
                  UtilService.notifyErrorAlert(
                    this.$vs,
                    "Number already exists."
                  );
                }
              })
              .catch(e => {
                console.log(e);
              });
          }
        }
        else{
          UtilService.notifyErrorAlert(
            this.$vs,
            "Please fill all mandatory fields."
          );
        }
      });
    },
    getPartnerVal() {
      PartnerService.getAll(this.userInfo).on("value", items => {
        this.partners = [];
        items.forEach(item => {
          let partnerVal = {};
          let key = item.key;
          let data = item.val();
          if (data["IsDeleted"] == 0) {
            partnerVal["label"] = data["CompanyName"];
            partnerVal["value"] = data["Id"];
            this.partners.push(partnerVal);
          }
        });
        this.partners.sort((a, b) => a.label.localeCompare(b.label))
      });
    },
    resetPayment(){
      this.Payment = {
        Partner: '',
        Amount: '',
        Subject: '',
        PaidDate: '',
        Description: '',
        IsHidden: 1,
        IsDeleted: 0,
        CreatedBy: "",
        ModifiedBy: ""
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.isSaveForm = false;
      this.resetPayment();
    },
  },
  created() {
    this.resetPayment();
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    this.userZone = this.userInfo.Timezone;
    if (this.$route.params.paymentId) {
      this.fetchPaymentData(this.$route.params.paymentId);
    }
    this.getPartnerVal();
  }
}
</script>
